var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 card mb-0 d-flex justify-content-center",class:`${_vm.mode == 'table' ? '' : 'm-0 shadow card-body '}`,style:(`height: ${_vm.mode == 'table' ? 'auto' : '60vh'};${
    _vm.color
      ? 'background:' + _vm.color + ';border-color: ' + _vm.color + '!important;'
      : ''
  }`)},[_c('div',{class:`${
      _vm.mode == 'table' ? 'px-0' : ''
    }  d-flex justify-content-center py-2`},[_c('img',{staticStyle:{"max-height":"60px"},attrs:{"src":"/img/load.svg"}})]),_vm._v(" "),(_vm.message)?_c('div',{staticClass:"col-auto mx-auto"},[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }